import { render } from "./PatientCalendarContent.vue?vue&type=template&id=be4b894e&ts=true"
import script from "./PatientCalendarContent.ts?vue&type=script&lang=ts&external"
export * from "./PatientCalendarContent.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__